import React from 'react';

import { Card, CardContent } from '@occc-app/design-system';
import {
  MembershipExternalIdentityVerificationProfileFragment,
  FuelAndConvenienceProfileFragment,
} from '@occc/graphql';

import FuelAndConvenienceProfile from './FuelAndConvenienceProfile';

import { IEaivMembershipStatistics } from '../../../../../dataAccessLayer/eaiv/types';

export interface IAudienceDetailsProps {
  fuelAndConvenienceProfile?: FuelAndConvenienceProfileFragment;
  eaivStatistics: IEaivMembershipStatistics;
  externalIdentityVerificationProfiles: MembershipExternalIdentityVerificationProfileFragment[];
}

const AudienceDetails: React.FC<IAudienceDetailsProps> = ({
  externalIdentityVerificationProfiles,
  fuelAndConvenienceProfile,
  eaivStatistics,
}) => {
  return (
    <Card sx={{ mb: 0 }}>
      <CardContent>
        <FuelAndConvenienceProfile
          profile={fuelAndConvenienceProfile}
          eaivStatistics={eaivStatistics}
          externalIdentityVerificationProfiles={externalIdentityVerificationProfiles}
        />
      </CardContent>
    </Card>
  );
};

export default AudienceDetails;
